<template>
  <div class="btn-group contenedor-quitar">
    <span v-on:click="eliminarRegistroNovedad(row.id)" class="chips text-left">
      <span class="icon icon-cross iconClose mr-1"></span>
      <span class="textClose ml-1">Quitar</span>
    </span>
    <span
      class="pr-1 elipsisCargo ml-1 text-rigth"
      style="width: 100%"
      v-b-tooltip.hover
      v-bind:title="row.name"
      >{{ row.name }}</span
    >
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "DeleteRow",
  data() {
    return {
      selected: false,
    };
  },
  props: ["row", "field"],
  computed: {
    ...mapState("modTipshiftReport", ["tipshift", "selectAll"]),
    ...mapGetters(["modTipshiftReport", ["getAllSelected"]]),
  },
  methods: {
    ...mapActions("modTipshiftReport", [
      "actSaveTipshift",
      "actGetTipshift",
      "actGetSelectAll",
      "actSelectRow",
      "actEliminarRegistroNovedad",
    ]),

    eliminarRegistroNovedad(id) {
      //if(){
      this.actEliminarRegistroNovedad(id);
      //}
      
    },
  },
};
</script>

<style lang="scss" scoped>
.textClose {
  position: static;
  height: 16px;
  left: 22px;
  right: 4px;
  top: calc(50% - 16px / 2);
  /* Placeholder */
  font-family: Open Sans;
  font-style: italic;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  /* Alert/Error */
  color: #da1414;
}

.iconClose {
  /* Alert/Error */
  color: #da1414;
}

.chips {
  /* Auto Layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px;
  position: static;
  width: 61px;
  left: calc(50% - 61px / 2 - 127.5px);
  top: 0%;
  bottom: 0%;
  /* Alert / Error Bg */
  background: #feefef;
  border-radius: 4px;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 16px;
}
</style>